import { useTranslation } from 'next-i18next';
import { QnA } from '@bridebook/toolbox/src/seo-facets/get-seo-data';
import FAQItem from './faq-item';

interface IProps {
  faqs: QnA[];
}

interface IFaqItemProps {
  faq: QnA;
}

const FaqItem = ({ faq }: IFaqItemProps) => (
  <>
    <FAQItem faq={faq} startOpen={false} />
    <hr className="bsfq-hr" />
  </>
);

const FAQ = ({ faqs }: IProps) => {
  const { t } = useTranslation('search');

  const filteredFAQs = (faqs || [])
    ?.map((faq) => ({
      ...faq,
      answer: faq?.answer?.trim?.() || '',
      question: faq?.question?.trim?.() || '',
    }))
    .filter((faq) => !!faq.answer && !!faq.question);

  if (!filteredFAQs?.length) return null;

  const halfArrLength =
    filteredFAQs.length % 2 == 0 ? filteredFAQs.length / 2 : filteredFAQs.length / 2 + 1;

  return (
    <div className="bsfq">
      <div className="bsfq-title">{t('faqSection.title')}</div>
      <div className="bsfq-cols">
        <div className="bsfq-col">
          {filteredFAQs.slice(0, halfArrLength).map((faq, index) => (
            <FaqItem faq={faq} key={index} />
          ))}
        </div>
        <div className="bsfq-col">
          {filteredFAQs.slice(halfArrLength).map((faq, index) => (
            <FaqItem faq={faq} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
